import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { generateQueryParams } from "../../lib/utils";

const initialState = {
  page: 0,
  rowsPerPage: 10,
  totalUsers: 0,
  data: [],
  filters: {},
  loading: false,
  error: null,
};

const CSSlice = createSlice({
  name: "allcus",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApisSuccess: (state, action) => {
      state.data = action.payload.users;
      state.totalUsers = action.payload.totalUsers;
      state.loading = false;
      state.error = null;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    requestFailure: (state, action) => {
      state = { ...initialState, error: action.payload };
    },
    updateCustomer: (state, action) => {
      const index = state.data.findIndex((r) => r._id === action.payload._id);
      if (index !== -1) {
        state.data[index] = action.payload;
      }
    },
  },
});

// Actions
export const {
  requestStart,
  ApisSuccess,
  requestFailure,
  setPage,
  setRowsPerPage,
  setFilters,
  updateCustomer,
} = CSSlice.actions;

export const CsSlice = (page, limit, filters) => async (dispatch) => {
  try {
    dispatch(requestStart());

    const response = await axios.get(
      `/private/backend/allcustomers?${generateQueryParams({
        ...filters,
        page,
        limit,
      })}`
    );
    dispatch(ApisSuccess(response.data));
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!"
    );
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export const UpdateCustomersAccountSlice = (data) => async (dispatch) => {
  try {
    const response = await axios.post("/private/backend/allcustomers", data);

    if (response?.data) {
      dispatch(updateCustomer(response.data));
      toast.success("Customer Account Updated!");
    }
    return null;
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || "Account creation failed!"
    );
    return null;
  }
};

export const DeleteCustomersAccountSlice = (data) => async (dispatch) => {
  try {
    const response = await axios.delete("/private/backend/allcustomers", {
      data,
    });

    if (response?.data) {
      dispatch(setFilters({}));
      toast.success("Account has been Deleted!");
    }
    return null;
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || "Account creation failed!"
    );
    return null;
  }
};

export default CSSlice.reducer;
